import { defineSlotRecipe } from '@chakra-ui/react';
import { getTokenValueOrString } from '../utils';
import { cardAnatomy } from '@chakra-ui/react/anatomy';

export type ThemeGenCardConfig = {
  borderRadius?: number;
};

export function generateCardSlotRecipe(config?: ThemeGenCardConfig) {
  return defineSlotRecipe({
    slots: cardAnatomy.keys(),
    base: {
      root: {
        borderRadius: getTokenValueOrString(config?.borderRadius, 'px')
      },
      header: {
        fontWeight: 'semibold',
        fontSize: 'md',
        lineHeight: '1.5rem',
        fontFamily: 'var(--fonts-heading)'
      },
      body: {},
      footer: {}
    },
    variants: {
      size: {
        xs: {
          root: {
            padding: '2px'
          },
          header: {
            padding: '2px 2px 0px 2px',
            fontSize: 'sm'
          },
          body: {
            padding: '2px',
            fontSize: 'xs'
          },
          footer: {
            padding: '2px',
            fontSize: 'xs'
          }
        },
        sm: {
          header: {
            paddingBottom: '2px'
          },
          body: {
            paddingTop: '2px'
          }
        },
        md: {
          header: {
            paddingBottom: '4px'
          },
          body: {
            paddingTop: '4px'
          }
        },
        lg: {
          header: {
            paddingBottom: '6px'
          },
          body: {
            paddingTop: '6px'
          }
        }
      },
      variant: {
        filterForm: {
          root: {
            background: 'bg.info',
            border: '1px solid #b1b1b1',
            borderRadius: '4px',
            boxShadow: 'none',
            padding: '4px 0px'
          },
          header: {
            padding: '4px 10px'
          },
          body: {
            padding: '10px'
          },
          footer: {
            padding: '4px 10px'
          }
        },
        fieldArray: {
          root: {
            background: 'bg.info',
            border: '1px solid #b1b1b1',
            borderRadius: '4px',
            boxShadow: 'none'
          },
          header: {
            padding: '10px'
          },
          body: {
            padding: '10px'
          },
          footer: {
            padding: '10px'
          }
        },
        toolbar: {
          root: {
            height: 'fit-content',
            width: '100%',
            margin: '4px 0',
            backgroundColor: 'bg.info',
            border: '1px solid #ececec',
            padding: '3px',
            boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)'
          },
          header: {
            padding: '0 !important',
            fontWeight: 'bold'
          },
          body: {
            padding: '0 !important',
            margin: '0 !important'
          },

          footer: {
            padding: '0px',
            margin: '0'
          }
        }
      }
    },
    defaultVariants: {
      size: 'sm'
    }
  });
}
